import { CountUp, Reveal } from "./Reveal";
import { TRUST_ITEMS } from "../data/content";

export const Trust = () => (
  <section className="bg-silver border-y border-line py-12 md:py-16" data-testid="trust-section">
    <div className="container-x">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8">
        {TRUST_ITEMS.map((s, i) => (
          <Reveal key={s.value} delay={i * 0.08}>
            <div
              className="group border-l-2 border-gold pl-5 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-herald"
              data-testid={`trust-metric-${i}`}
            >
              <p className="font-mono text-3xl md:text-4xl font-bold tracking-tight text-ink flex items-center gap-3 origin-left transition-transform duration-300 group-hover:scale-[1.06]">
                <CountUp value={s.value} />
                <span
                  className="w-2 h-2 bg-herald rotate-45 shrink-0 transition-transform duration-700 group-hover:rotate-[405deg]"
                  aria-hidden="true"
                />
              </p>
              <p className="text-[11px] uppercase tracking-[0.18em] text-muted mt-2 transition-colors duration-300 group-hover:text-ink/80">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
